import { NgModule } from '@angular/core';

import {
	AcousticEchoCancellationApiService,
	AutomaticGainControlApiService,
	BypassDspApiService,
	ChannelInfoApiService,
	CompressorApiService,
	ContextMenuApiService,
	DelayApiService,
	DenoiserApiService,
	DeverbApiService,
	LimiterApiService,
	NoiseReductionApiService,
	ParametricEqualizerApiService,
	SignalGeneratorApiService
} from '../api/services';

import {
	DaiBypassDspService,
	DaiChannelInfoApiService,
	DaiChannelInfoSubscriptionsService,
	DaiContextMenuStateApiService,
	DaiDeviceUiDspAecService,
	DaiDeviceUiDspAgcService
} from './services';
import { DaiDeviceUiDspCompressorService } from './services/dai-compressor.service';
import { DaiDeviceUiDspDelayService } from './services/dai-delay.service';
import { DaiDeviceUiDspDenoiserService } from './services/dai-denoiser.service';
import { DaiDeviceUiDspDeverbService } from './services/dai-deverb.service';
import { DaiDeviceUiDspLimiterService } from './services/dai-limiter.service';
import { DaiDeviceUiDspNoiseReductionService } from './services/dai-noise-reduction.service';
import { DaiDeviceUiDspParametricEqualizerService } from './services/dai-parametric-equalizer.service';
import { DaiDeviceUiDspSignalGeneratorService } from './services/dai-signal-generator.service';

@NgModule({
	providers: [
		DaiDeviceUiDspAecService,
		DaiBypassDspService,
		DaiDeviceUiDspAgcService,
		DaiDeviceUiDspCompressorService,
		DaiDeviceUiDspDelayService,
		DaiDeviceUiDspDenoiserService,
		DaiDeviceUiDspDeverbService,
		DaiDeviceUiDspLimiterService,
		DaiDeviceUiDspNoiseReductionService,
		DaiDeviceUiDspParametricEqualizerService,
		DaiDeviceUiDspSignalGeneratorService,
		DaiChannelInfoApiService,
		DaiChannelInfoSubscriptionsService,
		{
			provide: AcousticEchoCancellationApiService,
			useClass: DaiDeviceUiDspAecService
		},
		{
			provide: BypassDspApiService,
			useClass: DaiBypassDspService
		},
		{
			provide: AutomaticGainControlApiService,
			useClass: DaiDeviceUiDspAgcService
		},
		{
			provide: CompressorApiService,
			useClass: DaiDeviceUiDspCompressorService
		},
		{
			provide: DelayApiService,
			useClass: DaiDeviceUiDspDelayService
		},
		{
			provide: DenoiserApiService,
			useClass: DaiDeviceUiDspDenoiserService
		},
		{
			provide: DeverbApiService,
			useClass: DaiDeviceUiDspDeverbService
		},
		{
			provide: LimiterApiService,
			useClass: DaiDeviceUiDspLimiterService
		},
		{
			provide: NoiseReductionApiService,
			useClass: DaiDeviceUiDspNoiseReductionService
		},
		{
			provide: ParametricEqualizerApiService,
			useClass: DaiDeviceUiDspParametricEqualizerService
		},
		{
			provide: SignalGeneratorApiService,
			useClass: DaiDeviceUiDspSignalGeneratorService
		},
		{
			provide: ChannelInfoApiService,
			useClass: DaiChannelInfoApiService
		},
		{
			provide: ContextMenuApiService,
			useClass: DaiContextMenuStateApiService
		}
	]
})
export class SysApiDspDataAccessModule {}
